import { API_URL, CapitalizeFirstWord } from "../../helpers/utils";
import axios from "../../helpers/axios";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/dispatch";
import {
  decryptByText,
  requestPayloadBodyFormate,
  responseDataFormate,
} from "../../helpers/bycrypt";
import { NavigateFunction } from "react-router-dom";
import axiosInstance from "../../helpers/axios";
import { message } from "antd";

export const GetMachineListAPI =
  (
    {
      page,
      limit,
      search,
      plan_status,
      plan_type,
      is_active,
      start_date,
      end_date,
      sortBy,
      sortOrder,
      department,
    }: any,
    setHasMore: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getMachine", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (plan_status) params["plan_status"] = plan_status;
    if (plan_type) params["plan_type"] = plan_type;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;
    if (sortBy) params["sortBy"] = sortBy;
    if (sortOrder) params["sortOrder"] = sortOrder;
    if (is_active || is_active === 0) params["is_active"] = is_active;
    if (department) params["department"] = department;

    axiosInstance
      .get(`/machines`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_MACHINE_DATA",
            payload: {
              page: page,
              data: result?.data?.machines,
              count: result?.data?.total,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.machines?.length == limit);
          }
        } else {
          elseHandler(dispatch, "getMachine", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getMachine", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getMachine")(err);
        // navigate("/auth/login");
      });
  };

export const AddMachineAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addMachine", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`/machines`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) {
            onClose();
          }
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addMachine", undefined);
        } else elseHandler(dispatch, "addMachine", result);
        dispatchLoading(dispatch, "addMachine", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "addMachine")(e);
      });
  };

export const UpdateMachineDataAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateMachinData", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/machines`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "UPDATE_MACHINE_DATA",
            payload: result?.data,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateMachinData", undefined);
          onClose();
        } else elseHandler(dispatch, "updateMachinData", result);
        dispatchLoading(dispatch, "updateMachinData", false);
      })
      .catch(catchHandler(dispatch, "updateMachinData"));
  };

export const DeleteMachineAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    const formatedData = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteMachine", true);
    axios
      .delete(`/machines`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          onClose();
          dispatch({
            type: "DELETE_MACHINE",
            payload: data?.id,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteMachine", undefined);
        } else elseHandler(dispatch, "deleteMachine", result);
        dispatchLoading(dispatch, "deleteMachine", false);
      })
      .catch(catchHandler(dispatch, "deleteMachine"));
  };

export const GetMasterDataProductTypeAPI =
  () => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getProductType", true);
    axiosInstance
      .get(`/product-types`, {
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({ type: "GET_PRODUCT_TYPE", payload: result?.data?.data });
        } else {
          elseHandler(dispatch, "getProductType", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getProductType", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getProductType")(err);
        // navigate("/auth/login");
      });
  };

export const GetQuoteAdditionalInfoListAPI =
  ({ page, limit, search, product_type, category }: any, setHasMore: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getAdditionalInfo", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (product_type) params["product_type"] = product_type;

    if (category) params["category"] = category;

    axiosInstance
      .get(`/quotes/additional-info`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_QUOTE_ADDITIONAL_DATA",
            payload: {
              page: page,
              data: result?.data?.data,
              count: result?.data?.count,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
        } else {
          elseHandler(dispatch, "getAdditionalInfo", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getAdditionalInfo", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getAdditionalInfo")(err);
        // navigate("/auth/login");
      });
  };

export const UpdateQuoteAdditionalInfoAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateQuoteAdditionalInfo", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .patch(`/quotes/additional-info`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateQuoteAdditionalInfo", undefined);
          onClose(result);
        } else elseHandler(dispatch, "updateQuoteAdditionalInfo", result);
        dispatchLoading(dispatch, "updateQuoteAdditionalInfo", false);
      })
      .catch(catchHandler(dispatch, "updateQuoteAdditionalInfo"));
  };

export const GetQualityCheckListAPI =
  ({ search, department }: any, setHasMore?: any, onSuccess?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getQualityCheckList", true);
    let params: any = {};
    if (search) params["search"] = search;
    if (department) params["department"] = department;

    axiosInstance
      .get(`/quality-check-questions`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onSuccess) onSuccess(result?.data?.data);
          dispatch({
            type: "GET_QUALITY_CHECK_DATA",
            payload: {
              data: result?.data?.data,
              count: result?.data?.total,
            },
          });
        } else {
          elseHandler(dispatch, "getQualityCheckList", result);
        }
        dispatchLoading(dispatch, "getQualityCheckList", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getQualityCheckList")(err);
      });
  };

export const AddQualityCheckAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addQualityCheck", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`/quality-check-questions`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) {
            onClose();
          }
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addQualityCheck", undefined);
        } else elseHandler(dispatch, "addQualityCheck", result);
        dispatchLoading(dispatch, "addQualityCheck", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "addQualityCheck")(e);
      });
  };

export const UpdateQualityCheckAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateQualityCheck", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/quality-check-questions`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateQualityCheck", undefined);
          onClose();
        } else elseHandler(dispatch, "updateQualityCheck", result);
        dispatchLoading(dispatch, "updateQualityCheck", false);
      })
      .catch(catchHandler(dispatch, "updateQualityCheck"));
  };

export const DeleteQualityCheckAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    const formatedData = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteQualityCheck", true);
    axios
      .delete(`/quality-check-questions`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteQualityCheck", undefined);
        } else elseHandler(dispatch, "deleteQualityCheck", result);
        dispatchLoading(dispatch, "deleteQualityCheck", false);
      })
      .catch(catchHandler(dispatch, "deleteQualityCheck"));
  };

export const AddQualityCheckQuestionAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addQualityCheckQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`/quality-check-questions/question`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addQualityCheckQuestion", undefined);
        } else elseHandler(dispatch, "addQualityCheckQuestion", result);
        dispatchLoading(dispatch, "addQualityCheckQuestion", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "addQualityCheckQuestion")(e);
      });
  };

export const UpdateQualityCheckQuestionAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateQualityCheckQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/quality-check-questions/question`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateQualityCheckQuestion", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "updateQualityCheckQuestion", result);
        dispatchLoading(dispatch, "updateQualityCheckQuestion", false);
      })
      .catch(catchHandler(dispatch, "updateQualityCheckQuestion"));
  };

  export const AddReadinessCheckQuestionAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addReadinessCheckQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`/readiness-questions/create`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addReadinessCheckQuestion", undefined);
        } else elseHandler(dispatch, "addReadinessCheckQuestion", result);
        dispatchLoading(dispatch, "addReadinessCheckQuestion", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "addReadinessCheckQuestion")(e);
      });
  };

export const UpdateReadinessCheckQuestionAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateReadinessCheckQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/readiness-questions`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateReadinessCheckQuestion", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "updateReadinessCheckQuestion", result);
        dispatchLoading(dispatch, "updateReadinessCheckQuestion", false);
      })
      .catch(catchHandler(dispatch, "updateReadinessCheckQuestion"));
  };

export const AddReadinessQuestionAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addReadinessQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`/readiness-questions/question`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addReadinessQuestion", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "addReadinessQuestion", result);
        dispatchLoading(dispatch, "addReadinessQuestion", false);
      })
      .catch(catchHandler(dispatch, "addReadinessQuestion"));
  };

export const UpdateReadinessQuestionAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateReadinessQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/readiness-questions/question`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateReadinessQuestion", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "updateReadinessQuestion", result);
        dispatchLoading(dispatch, "updateReadinessQuestion", false);
      })
      .catch(catchHandler(dispatch, "updateReadinessQuestion"));
  };

export const DeleteReadinessQuestionAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "deleteReadinessQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .delete(`/readiness-questions/question`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteReadinessQuestion", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "deleteReadinessQuestion", result);
        dispatchLoading(dispatch, "deleteReadinessQuestion", false);
      })
      .catch(catchHandler(dispatch, "deleteReadinessQuestion"));
  };

export const GetReadinessCheckListAPI =
  ({ search }: any, onSuccess?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getReadinessCheckList", true);
    let params: any = {};
    if (search) params["search"] = search;

    axiosInstance
      .get(`/readiness-questions`, {
        params: { ...params },
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onSuccess) onSuccess(result?.data?.data);
          dispatch({
            type: "GET_READINESS_CHECK_DATA",
            payload: {
              data: result?.data?.data,
              count: result?.data?.total,
            },
          });
        } else {
          elseHandler(dispatch, "getReadinessCheckList", result);
        }
        dispatchLoading(dispatch, "getReadinessCheckList", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getReadinessCheckList")(err);
      });
  };

export const DeleteReadinessCheckQuestionAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    const formatedData = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteReadinessCheckQuestion", true);
    axios
      .delete(`/readiness-questions`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteReadinessCheckQuestion", undefined);
        } else elseHandler(dispatch, "deleteReadinessCheckQuestion", result);
        dispatchLoading(dispatch, "deleteReadinessCheckQuestion", false);
      })
      .catch(catchHandler(dispatch, "deleteReadinessCheckQuestion"));
  };

export const ReorderReadinessCheckQuestionAPI =
  (data: any, onSuccess: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "reorderReadinessCheckQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/readiness-questions/reorder`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "reorderReadinessCheckQuestion", undefined);
          onSuccess?.();
        } else elseHandler(dispatch, "reorderReadinessCheckQuestion", result);
        dispatchLoading(dispatch, "reorderReadinessCheckQuestion", false);
      })
      .catch(catchHandler(dispatch, "reorderReadinessCheckQuestion"));
  };



export const DeleteQualityCheckQuestionAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    const formatedData = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteQualityCheckQuestion", true);
    axios
      .delete(`/quality-check-questions/question`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteQualityCheckQuestion", undefined);
        } else elseHandler(dispatch, "deleteQualityCheckQuestion", result);
        dispatchLoading(dispatch, "deleteQualityCheckQuestion", false);
      })
      .catch(catchHandler(dispatch, "deleteQualityCheckQuestion"));
  };

export const ReorderQualityCheckQuestionAPI =
  (data: any, onSuccess: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "reorderQualityCheckQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/quality-check-questions/reorder`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "reorderQualityCheckQuestion", undefined);
          onSuccess?.();
        } else elseHandler(dispatch, "reorderQualityCheckQuestion", result);
        dispatchLoading(dispatch, "reorderQualityCheckQuestion", false);
      })
      .catch(catchHandler(dispatch, "reorderQualityCheckQuestion"));
  };

export const ReorderMachinesAPI =
  (data: any, onSuccess: any, onError: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "reorderMachine", true);
    axiosInstance
      .put(`/machines/reorder`, data)
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          onSuccess?.(result.data);
        } else {
          elseHandler(dispatch, "reorderMachine", result);
          onError?.();
        }
        dispatchLoading(dispatch, "reorderMachine", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "reorderMachine")(err);
        onError?.();
      });
  };

interface GetMachineDetailsParams {
  machineId: string;
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const getMachineDetailsAPI =
  ({ machineId, onSuccess, onError }: GetMachineDetailsParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get(
        `/machines/${machineId}/orders-in-production `,
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Get Machine Details Error:", error);
      message.error(
        error?.response?.data?.message || "Failed to fetch machine details",
      );
      onError?.();
    }
  };

export const GetDispatchChecklistAPI =
  ({ search, department }: any, setHasMore?: any, onSuccess?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getDispatchChecklist", true);
    let params: any = {};
    if (search) params["search"] = search;
    if (department) params["department"] = department;

    axiosInstance
      .get(`/dispatch-checklist`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onSuccess) onSuccess(result?.data?.data);
          dispatch({
            type: "GET_DISPATCH_CHECKLIST_DATA",
            payload: {
              data: result?.data?.data,
              count: result?.data?.total,
            },
          });
        } else {
          elseHandler(dispatch, "getDispatchChecklist", result);
        }
        dispatchLoading(dispatch, "getDispatchChecklist", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getDispatchChecklist")(err);
      });
  };

export const DeleteDispatchChecklistAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    const formatedData = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteDispatchChecklist", true);
    axios
      .delete(`/dispatch-checklist`, {
        data: formatedData, 
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteDispatchChecklist", undefined);
        } else elseHandler(dispatch, "deleteDispatchChecklist", result);
        dispatchLoading(dispatch, "deleteDispatchChecklist", false);
      })
      .catch(catchHandler(dispatch, "deleteDispatchChecklist"));
  };

export const AddDispatchChecklistAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addDispatchChecklist", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`/dispatch-checklist`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) {
            onClose();
          }
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addDispatchChecklist", undefined);
        } else elseHandler(dispatch, "addDispatchChecklist", result);
        dispatchLoading(dispatch, "addDispatchChecklist", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "addDispatchChecklist")(e);
      });
  };

export const UpdateDispatchChecklistAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDispatchChecklist", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/dispatch-checklist`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateDispatchChecklist", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "updateDispatchChecklist", result);
        dispatchLoading(dispatch, "updateDispatchChecklist", false);
      })
      .catch(catchHandler(dispatch, "updateDispatchChecklist"));
  };

export const AddDispatchChecklistQuestionAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "addDispatchChecklistQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .post(`/dispatch-checklist/question`, formatedData, {
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "addDispatchChecklistQuestion", undefined);
        } else elseHandler(dispatch, "addDispatchChecklistQuestion", result);
        dispatchLoading(dispatch, "addDispatchChecklistQuestion", false);
      })
      .catch((e) => {
        catchHandler(dispatch, "addDispatchChecklistQuestion")(e);
      });
  };

export const UpdateDispatchChecklistQuestionAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateDispatchChecklistQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/dispatch-checklist/question`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateDispatchChecklistQuestion", undefined);
          if (onClose) onClose();
        } else elseHandler(dispatch, "updateDispatchChecklistQuestion", result);
        dispatchLoading(dispatch, "updateDispatchChecklistQuestion", false);
      })
      .catch(catchHandler(dispatch, "updateDispatchChecklistQuestion"));
  };

export const DeleteDispatchChecklistQuestionAPI =
  (data: any, onClose: any) => (dispatch: (action: any) => void) => {
    const formatedData = requestPayloadBodyFormate(data);
    dispatchLoading(dispatch, "deleteDispatchChecklistQuestion", true);
    axios
      .delete(`/dispatch-checklist/question`, {
        data: formatedData,
        withCredentials: true,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          onClose();
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "deleteDispatchChecklistQuestion", undefined);
        } else elseHandler(dispatch, "deleteDispatchChecklistQuestion", result);
        dispatchLoading(dispatch, "deleteDispatchChecklistQuestion", false);
      })
      .catch(catchHandler(dispatch, "deleteDispatchChecklistQuestion"));
  };

export const ReorderDispatchChecklistQuestionAPI =
  (data: any, onSuccess: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "reorderDispatchChecklistQuestion", true);
    const formatedData = requestPayloadBodyFormate(data);
    axios
      .put(`/dispatch-checklist/reorder`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "reorderDispatchChecklistQuestion", undefined);
          onSuccess?.();
        } else elseHandler(dispatch, "reorderDispatchChecklistQuestion", result);
        dispatchLoading(dispatch, "reorderDispatchChecklistQuestion", false);
      })
      .catch(catchHandler(dispatch, "reorderDispatchChecklistQuestion"));
  };
    
